export const ADMIN_ROLE = 'admin';
export const ADMIN_CLIENT_ROLE = 'adminClient';
export const PARTNER_ROLE = 'partner';
export const ALL_CLIENTS = 'allClients';
